import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getIdFiche',
})
export class GetIdFichePipe implements PipeTransform {
  transform(value?: string): string {
    if (!value) return '';
    return value.substring(4, value.length);
  }
}
